import React, { useState, Children, memo } from 'react';
import { motion } from 'framer-motion';
import { BouncingSign } from './components/BouncingSign';
import { ContactModal } from './components/ContactModal';
import { ArrowRightIcon } from 'lucide-react';
export function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Animation variants for staggered entrance
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <div className="min-h-screen bg-black flex flex-col items-center justify-center relative overflow-hidden selection:bg-[#FFD700] selection:text-black" data-id="element-0">
      {/* Ambient background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#FFD700]/5 rounded-full blur-[120px] pointer-events-none" data-id="element-1" />

      <BouncingSign data-id="element-2" />

      <motion.div className="z-10 flex flex-col items-center justify-center text-center px-6 max-w-4xl mx-auto" variants={containerVariants} initial="hidden" animate="visible" data-id="element-3">
        <motion.div variants={itemVariants} className="mb-4" data-id="element-4">
          <span className="text-white/90 text-2xl md:text-4xl lg:text-5xl font-bold tracking-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-5">
            totemrestobar.com
          </span>
        </motion.div>

        <motion.div variants={itemVariants} className="mb-6" data-id="element-6">
          <span className="text-[#FFD700] uppercase tracking-[0.3em] text-sm font-medium opacity-80" data-id="element-7">
            Premium Domain
          </span>
        </motion.div>

        <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl lg:text-8xl font-bold text-[#FFD700] mb-8 leading-tight text-glow-gold" animate={{
        textShadow: ['0 0 20px rgba(255, 215, 0, 0.2), 0 0 40px rgba(255, 215, 0, 0.05)', '0 0 30px rgba(255, 215, 0, 0.4), 0 0 60px rgba(255, 215, 0, 0.15)', '0 0 20px rgba(255, 215, 0, 0.2), 0 0 40px rgba(255, 215, 0, 0.05)']
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-8">
          This Domain is
          <br data-id="element-9" />
          For Sale.
        </motion.h1>

        <motion.p variants={itemVariants} className="text-lg md:text-xl text-zinc-300 max-w-2xl mb-12 font-light leading-relaxed" data-id="element-10">
          A premium domain ready to elevate your brand. Unique, memorable, and
          the perfect fit for your next big project.
        </motion.p>

        <motion.div variants={itemVariants} data-id="element-11">
          <button onClick={() => setIsModalOpen(true)} className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-transparent border border-[#FFD700] text-[#FFD700] font-medium text-lg rounded-full overflow-hidden transition-all hover:scale-105" data-id="element-12">
            {/* Hover background fill */}
            <div className="absolute inset-0 bg-[#FFD700] translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300 ease-in-out" data-id="element-13" />

            <span className="relative z-10 group-hover:text-black transition-colors duration-300" data-id="element-14">
              Connect With Us
            </span>
            <ArrowRightIcon size={20} className="relative z-10 group-hover:text-black group-hover:translate-x-1 transition-all duration-300" data-id="element-15" />
          </button>
        </motion.div>
      </motion.div>

      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-16" />
    </div>;
}